import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import moment, { Moment } from 'moment';
import { DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY, timeTypeObj } from '@/pages/dashboard/_config/constant';
import { setBtnPointLog } from '@/pages/dashboard/utils/utils';
import { renderCompetitor, renderSource } from './FilterList';
import TimePickerSwitch from '@/pages/dashboard/components/TimePickerSwitch';
import { useFilterData } from './hooks';
import { RANGE_DATE, RANGE_DAY_MONTH } from '../../components/NewFilter/FilterBase/_config';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { storage } from '@/utils/utils';
import { getDateDefault } from '../../utils/dateUtils';
import { shallowEqual, useSelector } from 'umi';
import { GAME_DATE_TYPE_MAP } from '../../pages/competitor/_config/constants';
import { getSourceExcludeList } from '../../pages/competitor/_config/utils';

// 日期格式化
const getResetRangeTime = (defaultType?: string, timeZone = 0) => {
  const format = timeTypeObj.Day;
  const resetType = defaultType || 'month';
  const timeType = resetType === 'date' ? 'day' : resetType;
  const startNum = resetType === 'date' ? 30 : resetType === 'week' ? 8 : 6;
  const rangeValue = getDateDefault({
    timeType,
    timeZone,
    startNum,
    endNum: 1,
  });

  if (!Array.isArray(rangeValue)) {
    return {
      type: resetType,
      value: ['', ''],
    };
  }

  return {
    type: resetType,
    value: [rangeValue[0].format(format), rangeValue[1].format(format)],
  };
};

interface IFormatMoment {
  format: (f: string) => string;
}

interface IRangeTimeValue {
  type?: string;
  value?: IFormatMoment[];
}

interface ICompetitorItem {
  is_competitor?: boolean;
  unified_id?: string;
}

interface IFilterSaveValue {
  ext_filter?: {
    alignedType?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

interface ILaunchConfig {
  type?: string;
  value?: string[];
}

const formatDateFromFilterValue = (
  value: Record<string, unknown>,
  selector: Record<string, unknown>,
  isReset?: boolean,
  defaultType?: string,
  timeZone = 0,
): Record<string, unknown> => {
  const { competitor } = (value || { rangeTime: { type: '', value: [] } }) as Record<string, unknown>;
  const rangeTime = value?.rangeTime as IRangeTimeValue | undefined;
  const val = rangeTime?.value;
  const type = rangeTime?.type || '';
  const competitorList = ((selector as Record<string, ICompetitorItem[]>)?.competitor_list) || [];
  const currentGame = competitorList?.filter((item) => !item?.is_competitor)?.[0];
  const allCompetitors = competitorList?.filter((item) => item?.is_competitor);
  const selectedCompetitors = (competitor as string[])?.map((v: string) => allCompetitors?.find((item) => item?.unified_id === v)).filter(Boolean);
  const format = timeTypeObj.Day;
  return {
    ...value,
    competitor: [currentGame, ...selectedCompetitors],
    ...((isReset || !type) ? { rangeTime: getResetRangeTime(defaultType, timeZone) } : {rangeTime: {
      type,
      value: [val?.[0]?.format(format), val?.[1]?.format(format)],
    }})
  };
};
// 筛选器路径


/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// KeyMetricsFilter筛选器继承逻辑
const KeyMetricsFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, openSticky = false, competitorReqType} = props;
  const [isLaunchTime, setIsLaunchTime] = useState(false);
  const [isEarliestData, setIsEarliestData] = useState<boolean>(false);
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新

  const FILTER_PATH = '/competitor/index';
  const { loading, selectorSchemeList, getOutSelectorSchemeList, selector } = useFilterData(FILTER_PATH);
  const { locale, getLocalText } = useLocal();
  const { timeZone, gameCode, dataFrame } = useSelector((state: any) => ({
    timeZone: parseInt(state?.dashboardSetting?.gameConfig?.time_zone || '', 10) || 0,
    gameCode: state?.dashboard?.currentGame?.game_code || '',
    dataFrame: state?.dashboard?.currentGame?.data_frame || '',
  }), shallowEqual);
  const alignedByList = useMemo(() => [
    {
      name: "Launch Time",
      text: getLocalText('competitor_launch'),
      textId: 'competitor_launch',
      value: "launch_time"
    },
    {
      name: "Earliest Date",
      text: getLocalText('competitor_earliest_data'),
      textId: 'competitor_earliest_data',
      value: "earliest_data"
    }
  ], [locale]);

  const [currentAlignedBy, setCurrentAlignedBy] = useState<string>('');

  const [inputDayMonthInit,setInputDayMonthInit] = useState({
    key: 'rangeDayMonth',
    alignedBy: alignedByList[0],
    default: {
      type: 'Day',
      value: ['1', '30']
    },
  });


  useEffect(() => {
    setIsEarliestData(currentAlignedBy === 'earliest_data');

    const alignedBy = alignedByList.find((item) => item.value === currentAlignedBy);

    if (alignedBy) {
      setInputDayMonthInit({
        key: 'rangeDayMonth',
        alignedBy,
        default: {
          type: 'Day',
          value: ['1', '30']
        },
      });
    } else {
      setInputDayMonthInit({
        key: 'rangeDayMonth',
        alignedBy: alignedByList[0],
        default: {
          type: 'Day',
          value: ['1', '30']
        },
      });
    }

  }, [currentAlignedBy]);



  // const  INPUT_DAY_MONTH = useMemo(()=>{
  //   return {
  //     key: 'rangeDayMonth',
  //     default: {
  //       type: 'Day',
  //       value: ['1', '30']
  //     },
  //   }
  // },[])
  // 设置inputList
  const dateTypeConfig = GAME_DATE_TYPE_MAP[gameCode];
  const sourceExcludeList = useMemo(
    () => getSourceExcludeList(dataFrame, gameCode),
    [dataFrame, gameCode],
  );

  const inputList = useMemo(() => {
    if (loading) return [];
    const { source_list: sourceList, competitor_list: competitorList } = selector;
    const filteredSourceList = sourceExcludeList.length > 0
      ? sourceList?.filter((item: any) => !sourceExcludeList.includes(item?.value))
      : sourceList;
    const sourceDefault = filteredSourceList?.find((item: any) => item?.value === 'sensortower') || filteredSourceList?.[0];

    const defaultDateType = dateTypeConfig?.defaultType || 'month';
    const defaultTypeList = dateTypeConfig?.typeList
      || (competitorReqType === "normal" ? ['date', 'week', 'month'] : ['week', 'month']);

    return [
      isLaunchTime ? inputDayMonthInit : {
        type: RANGE_DATE,
        key: 'rangeTime',
        default: {
          type: defaultDateType,
          value: getDateDefault({ timeType: defaultDateType, timeZone, startNum: defaultDateType === 'date' ? 30 : defaultDateType === 'week' ? 8 : 6, endNum: 1 }),
        },
        componentDefault: {
          date: getDateDefault({ timeType: 'day', timeZone, startNum: 30, endNum: 1 }),
          week: getDateDefault({ timeType: 'week', timeZone, startNum: 8, endNum: 1 }),
          month: getDateDefault({ timeType: 'month', timeZone, startNum: 6, endNum: 1 }),
        },
        typeList: defaultTypeList,
        disabledDate: {
          date: (date:Moment, start:Moment | undefined) => {
            const isAfterToday = date.isAfter(moment(), "day");
            const isTwoYearsBefore = moment(date).isAfter(moment(start).add(2, "years"));
            const isTwoYearsAfter = moment(date).isBefore(moment(start).subtract(2, "years"));
            if (moment.isMoment(start)) {
              return (
                !isAfterToday &&
                  !(
                    isTwoYearsBefore || isTwoYearsAfter
                  )
              );
            }
            return !isAfterToday;
          },
        },
        startOfDate: moment().subtract(2, 'years')?.format('YYYY-MM-DD')
      },
      {
        key: 'competitor',
        default: (competitorList || []).map((item: any) => item.unified_id),
        render: renderCompetitor
      },
      {
        key: 'region',
        default: {
          region_type: 'market',
          markets: ["255"],
          regions: []
        },
      },
      {
        key: 'system',
        default: ["255"],
      },
      {
        key: 'source',
        optionDataKey: 'source_list',
        default: sourceDefault?.value || '',
        render: renderSource
      }
    ];
  }, [isLaunchTime, loading, inputDayMonthInit, inputDayMonthInit?.toString(), competitorReqType, gameCode, sourceExcludeList]);


  // 筛选器保存页面展示的默认方案，
  const defaultSelectedItem = useMemo(() => selectorSchemeList?.filter((item: any) => item.filter_cond.is_default)?.[0] || [], [selectorSchemeList]);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value: Record<string, unknown>) => {
    // 方案传承 > 默认方案
    const filterStorageSave = storage.getItem(DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY);
    const currentFilter = filterStorageSave || defaultSelectedItem;

    const rangeDayMonthVal = currentFilter?.filter_cond?.ext_filter?.[RANGE_DAY_MONTH];

    setIsLaunchTime(!!rangeDayMonthVal);

    const currentAlignedType = currentFilter?.filter_cond?.ext_filter?.alignedType;

    setIsEarliestData(currentAlignedType === "earliest_data");
    setCurrentAlignedBy(!!rangeDayMonthVal ? currentAlignedType === "earliest_data" ? "earliest_data" : "launch_time" : '');

    if(rangeDayMonthVal) {
      value[RANGE_DAY_MONTH] = rangeDayMonthVal;
    }

    filterValueRef.current = value;

    if (filterValueRef.current && !filterValueRef.current.rangeTime) {
      const fallbackType = dateTypeConfig?.defaultType || 'month';
      filterValueRef.current.rangeTime = {
        type: fallbackType,
        value: getDateDefault({ timeType: fallbackType, timeZone, startNum: fallbackType === 'date' ? 30 : fallbackType === 'week' ? 8 : 6, endNum: 1 }),
      };
    }

    // todo 锁定状态下如果锁定时间跟默认时间相同，是否需要单独处理，设置diff为false？

    filterInit({
      filterValue: formatDateFromFilterValue(value, selector, false, dateTypeConfig?.defaultType, timeZone),
      newFilter: true,
      selector,
      isLaunchTime: rangeDayMonthVal ? currentAlignedType !== "earliest_data" : isLaunchTime,
      isEarliestData: currentAlignedType === "earliest_data" ? true : isEarliestData,
    });
  }, [filterInit, isLaunchTime, selector, isEarliestData, dateTypeConfig, timeZone]);

  const onConfirm = useCallback((value: Record<string, unknown>) => {
    // filterValueRef.current = value;
    const obj = {
      filterValue: formatDateFromFilterValue(value, selector, false, dateTypeConfig?.defaultType, timeZone),
      newFilter: true,
      isLaunchTime,
      isEarliestData,
      selector,
    };
    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj?.filterValue);
  }, [filterConfirm, isLaunchTime, selector, isEarliestData, dateTypeConfig, timeZone]);

  const onReset = useCallback((value: Record<string, unknown>) => {
    const { rangeTime, rangeDayMonth, rangeDate, ...filters } = value as Record<string, unknown>;
    const resetType = dateTypeConfig?.defaultType || 'month';
    filterValueRef.current = {
      ...filters,
      rangeTime: {
        type: resetType,
        value: getDateDefault({ timeType: resetType, timeZone, startNum: resetType === 'date' ? 30 : resetType === 'week' ? 8 : 6, endNum: 1 }),
      }
    };
    // todo reset 的时候是否同时要初始化isLaunchTime
    setIsLaunchTime(false);
    setIsEarliestData(false);
    setCurrentAlignedBy('');

    const obj = {
      filterValue: formatDateFromFilterValue(value, selector, true, dateTypeConfig?.defaultType, timeZone),
      newFilter: true,
      isLaunchTime: false,
      selector,
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj?.filterValue, true);
  }, [filterReset, isLaunchTime, isEarliestData, selector, dateTypeConfig, timeZone]);

  const handleChangeLaunchTime = (value: boolean): void => {
    const { rangeTime, rangeDayMonth, rangeDate, ...filters } = filterValueRef.current || {};

    filterValueRef.current = filters;

    if (!rangeDayMonth) {
      filterValueRef.current.rangeDayMonth = inputDayMonthInit.default;
    }

    filterValueRef.current.rangeTime = rangeTime || {
      type: 'month',
      value: [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    };

    setIsLaunchTime(value);
    setIsEarliestData(value && currentAlignedBy === "earliest_data");

    if (!value) {
      setCurrentAlignedBy('');
    } else {
      setCurrentAlignedBy('launch_time');
    }
  };

  const filterSaveOnChange = (inputList: Record<string, unknown>[], value: IFilterSaveValue) => {
    const filterSaveIsLaunch = value?.ext_filter?.[RANGE_DAY_MONTH];

    setIsLaunchTime(!!filterSaveIsLaunch);
    setCurrentAlignedBy(!!filterSaveIsLaunch ? (value?.ext_filter?.alignedType || 'launch_time') : '');
    setIsEarliestData(!!filterSaveIsLaunch && value?.ext_filter?.alignedType === "earliest_data");

    if(filterSaveIsLaunch) {
      const launchConfig = filterSaveIsLaunch as ILaunchConfig;
      setInputDayMonthInit(
        {
          key: 'rangeDayMonth',
          alignedBy: alignedByList[value?.ext_filter?.alignedType === "earliest_data" ? 1 : 0],
          default: {
            type: launchConfig?.type || 'Day',
            value: launchConfig?.value || ['1', '30']
          },
        }
      );
    }
    const resultInputList = inputList?.map((item: Record<string, unknown>) => {
      const key = item?.type || item?.key;
      if(filterSaveIsLaunch && key === RANGE_DATE) {
        return {
          key: 'rangeDayMonth',
          default: {
            type: 'Day',
            alignedBy: alignedByList[0],
            value: ['1', '30']
          },
        };
      }
      if(!filterSaveIsLaunch  && key === RANGE_DAY_MONTH) {
        const saveDefaultType = dateTypeConfig?.defaultType || 'month';
        const saveTypeList = dateTypeConfig?.typeList
          || (competitorReqType === "normal" ? ['date', 'week', 'month'] : ['week', 'month']);
        return {
          type: RANGE_DATE,
          key: 'rangeTime',
          default: {
            type: saveDefaultType,
            value: getDateDefault({ timeType: saveDefaultType, timeZone, startNum: saveDefaultType === 'date' ? 30 : saveDefaultType === 'week' ? 8 : 6, endNum: 1 }),
          },
          componentDefault: {
            date: [moment().subtract(30, 'day'), moment().subtract(1, 'day')],
            week: [moment().subtract(8, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
            month: [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
          },
          typeList: saveTypeList,
          disabledDate: {
            date: (date:Moment, start:Moment | undefined) => {
              const isAfterToday = date.isAfter(moment(), "day");
              const isTwoYearsBefore = moment(date).isAfter(moment(start).add(2, "years"));
              const isTwoYearsAfter = moment(date).isBefore(moment(start).subtract(2, "years"));
              if (moment.isMoment(start)) {
                return (
                  !isAfterToday &&
                    !(
                      isTwoYearsBefore || isTwoYearsAfter
                    )
                );
              }
              return !isAfterToday;
            },
          },
          startOfDate: moment().subtract(2, 'years')?.format('YYYY-MM-DD')
        };
      }
      return item;
    });

    return resultInputList;
  };



  const filteredSelector = useMemo(() => {
    if (!selector || !sourceExcludeList.length) return selector;
    return {
      ...selector,
      source_list: selector.source_list?.filter((item: any) => !sourceExcludeList.includes(item?.value)),
    };
  }, [selector, sourceExcludeList]);

  return < Filter
    path={FILTER_PATH}
    openSticky={openSticky}
    // isHaveFilterCache={false}
    // isHaveFilterSave={false}
    key={filterValueRef.current}
    loading={loading}
    useOutInput={true}
    outSelector={filteredSelector}
    outSelectorSchemeList={selectorSchemeList}
    getOutSelectorSchemeList={getOutSelectorSchemeList}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
    filterSaveOnChange={filterSaveOnChange}
    topSlot={
      <TimePickerSwitch
        value={isLaunchTime}
        defaultValue={isLaunchTime}
        onChange={handleChangeLaunchTime}
        currentAlignedBy={currentAlignedBy}
        setCurrentAlignedBy={setCurrentAlignedBy}
        alignedByList={alignedByList}
      />
    }
    alignedType={currentAlignedBy}
  />;
};

export default KeyMetricsFilter;
